import CardNew from 'presentation/shared/components/CardNew'
import styled from 'styled-components'

export const StyledCardNew = styled(CardNew)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  align-items: center;
`
export const ReasonTitle = styled.div`
  font-size: 12px;
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.ds.colors.neutral700};
`
export const ReasonValue = styled.div`
  font-size: 12px;
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.ds.colors.neutral700};
`
export const StatusHelpCardTitle = styled.span`
  font-weight: ${({ theme }) => theme.font.semiBold};
  color: ${({ theme }) => theme.ds.colors.neutral700};

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }

  @media screen and (min-width: 769px) {
    font-size: 14px;
  }
`

export const PercentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-right: auto;
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.ds.colors.neutral700};
`

export const AppendIcon = styled.div`
  margin-top: 8px;
  margin-right: 8px;
`

export const Grid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 2fr 20fr 1fr 1fr;
`
